// @ts-ignore untype dependencys
import standOutImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/stand-out-icon.svg';
import { Big } from 'foundations-components/transitional/components/Big';
// @ts-ignore untype dependencys
import customizeImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/customize-website-icon.svg';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { getModulesStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ModulesSection({
  onTrackInteraction
}) {
  const {
    flexDirection,
    width
  } = useResponsiveProps({
    flexDirection: {
      xs: 'column',
      md: 'row'
    },
    width: {
      xs: undefined,
      md: '50%'
    }
  });
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    paddingInline: "1000",
    paddingBlock: "500",
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h1",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.templates.modules.title"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: flexDirection,
      padding: "1000",
      marginBlockEnd: "400",
      justifyContent: "center",
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        marginInlineEnd: "400",
        flexDirection: "column",
        minInlineSize: width,
        children: [/*#__PURE__*/_jsx(Image, {
          paddingBlockEnd: "1000",
          maxBlockSize: "180px",
          responsive: false,
          src: customizeImageUrl,
          role: "presentation"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h3",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.modules.customizeTitle"
          })
        }), /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.modules.customizeSubtitle"
            })
          })
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        marginInlineEnd: "400",
        flexDirection: "column",
        minInlineSize: width,
        children: [/*#__PURE__*/_jsx(Image, {
          paddingBlockEnd: "1000",
          maxBlockSize: "180px",
          responsive: false,
          src: standOutImageUrl,
          role: "presentation"
        }), /*#__PURE__*/_jsx(Text, {
          as: "h3",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.modules.standOutTitle"
          })
        }), /*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.modules.standOutSubtitle"
            })
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(RouterButton, {
      onClick: () => {
        onTrackInteraction('click modules storefront link');
      },
      to: getModulesStorefrontRoute(),
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.templates.modules.button"
      })
    })]
  });
}